/* eslint-disable @typescript-eslint/no-explicit-any */
// Self-contained HTTP client for the Hub admin feature.
// Uses an axios instance with a baseURL (REACT_APP_API_URL) so the Hub action
// files can call relative paths like `/marketplace/list`, exactly as they did
// in the source project. Kept separate from the app's fetch-based
// `services/backend.service` so existing pages are unaffected.
import axios, { AxiosResponse } from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

const api = axios.create({ baseURL: API_URL });

// Attach the admin auth token on every request. Both header names are sent for
// backend compatibility (matches the app's existing fetch service).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
    config.headers.set('x-auth-token', token);
  }
  return config;
});

export const services = {
  get: <T = any,>(url: string, header?: any): Promise<AxiosResponse<T>> =>
    api.get<T>(url, { headers: header }),
  post: <T = any,>(url: string, params?: any, header?: any): Promise<AxiosResponse<T>> =>
    api.post<T>(url, params, { headers: header }),
  put: <T = any,>(url: string, params?: any, header?: any): Promise<AxiosResponse<T>> =>
    api.put<T>(url, params, { headers: header }),
  patch: <T = any,>(url: string, params?: any, header?: any): Promise<AxiosResponse<T>> =>
    api.patch<T>(url, params, { headers: header }),
  delete: <T = any,>(url: string, header?: any): Promise<AxiosResponse<T>> =>
    api.delete<T>(url, { headers: header }),
};
